
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.86 10.284a.3.3 0 01.28 0l7.367 3.907a.5.5 0 010 .884l-7.039 3.732a1 1 0 01-.937 0l-7.038-3.732a.5.5 0 010-.884l7.366-3.907z","fill":"#999"}}),_c('path',{attrs:{"d":"M10.234 4.84L10 4.716l-.234.124-7.507 3.982a1 1 0 000 1.767l.234-.442-.234.442 7.038 3.732a1.5 1.5 0 001.406 0l7.038-3.732-.234-.442.234.442a1 1 0 000-1.767L10.234 4.84zm2.77 4.865L10 11.298 6.996 9.705 10 8.112l3.004 1.593z","fill":"#999","stroke":"#fff"}}),_c('path',{attrs:{"d":"M6.924 3.676h0L9.33 1.032s0 0 0 0c.364-.401.975-.401 1.34 0L6.924 3.675zm0 0a.97.97 0 00-.186.993c.113.305.406.6.837.6h1.127v3.994c0 .471.355.942.899.942h.798c.544 0 .9-.47.9-.942V5.268h1.126c.431 0 .724-.294.838-.6a.97.97 0 00-.188-.992s0 0 0 0L10.67 1.032 6.924 3.676z","fill":"#999","stroke":"#fff"}})])
          )
        }
      }
    